import {Meta, PaginationRequest} from '~/types/types';
import {httpApiV3, useVzFetch} from '~/composables/useVzFetch';
import {IRequestError, VZResponse} from '~/types/api';
import {OrderV3, TemplateOrder} from '~/types/order/orderV3';
import {clearEmpties, deepCopyObject} from '~/common/functions';

export function getTemplateList(requestData: PaginationRequest & { name?: string, favorite?: 0|1|number }, signal: AbortSignal|undefined = undefined) {
  return useVzFetch(
      `${httpApiV3}/personal/order/template`,
      { method: 'GET', params: requestData, signal }
  ) as Promise<{ data: TemplateOrder[], meta: Meta } & { error?: IRequestError }>
}

export function createTemplate(orderData: Partial<OrderV3>, name: string|undefined = undefined) {
  orderData = prepareTemplate(orderData)
  return useVzFetch(
      `${httpApiV3}/personal/order/template`,
      { method: 'POST', body: { orderData, name } }
  ) as Promise<TemplateOrder & { error?: IRequestError }>
}

export function updateTemplate(id: string|number, body: { orderData?: Partial<OrderV3>, name?: string, favorite?: boolean, default?: boolean }) {
  if (body.orderData) {
    body.orderData = prepareTemplate(body.orderData)
  }
  return useVzFetch(
      `${httpApiV3}/personal/order/template/${id}`,
      { method: 'PUT', body }
  ) as Promise<TemplateOrder & { error?: IRequestError }>
}

export function getTemplate(id: string|number|Array<string|number>, relevant = false) {
  return useVzFetch<VZResponse<TemplateOrder>>(
      `${httpApiV3}/personal/order/template/${id}`,
      { params: relevant ? { relevant : 1 } : {} }
  )
}

export function sortTemplate(id: number, sort: number) {
  return useVzFetch(
      `${httpApiV3}/personal/order/template/sort/${id}`,
      { method: 'PUT', body: { sort } }
  ) as Promise<{ error?: IRequestError }>
}

export function removeTemplate(id: string|number) {
  return useVzFetch(
      `${httpApiV3}/personal/order/template/${id}`,
      { method: 'DELETE' }
  ) as Promise<{ message: string } & { error?: IRequestError }>
}

export function getDefaultTemplate() {
  return useVzFetch(`${httpApiV3}/personal/order/template/default`) as Promise<TemplateOrder & { error?: IRequestError }>
}

export function templateFeedback(body: { templateId: number|null, content: string }) {
  return useVzFetch(
      `${httpApiV3}/personal/order/template/feedback`,
      { method: 'POST', body }
  ) as Promise<{ error?: IRequestError, message?: string }>
}

function prepareTemplate(orderData: Partial<OrderV3>) {
  orderData = deepCopyObject(orderData)
  if (orderData) {
    const setInsuranceFalse = orderData?.services?.insurance?.active === false
    if (setInsuranceFalse && orderData?.services?.insurance) {
      orderData.services.insurance.active = true
    }
    orderData = clearEmpties(orderData, true)
    if (setInsuranceFalse && orderData?.services?.insurance) {
      orderData.services.insurance.active = false
    }
  }
  return orderData
}
